<template>
  <div class="help col-12 d-flex flex-column">

    <div class="row justify-content-center mb-5">
      <div class="content-wrapper col-12">

      <h2 class="mb-3 pb-1 border-bottom">Часто задаваемые вопросы</h2>

      <div
        id="questionsBlock"
        class="mb-3"
      >
        <div
          v-for="(question, index) in questions"
          :key="index"
          :id="'question_'+question.id"
          class="panel panel-default mb-2"
        >
          <div
            class="panel-heading py-3 pl-2 bg-light"
            :id="'q_head_'+question.id"
          >
            <h5
              class="panel-title m-0 text-secondary"
              :id="'q_title_'+question.id"
            >
              <a
                :href="'#q_collapse_'+question.id"
                v-on:click.prevent="showForm(question.id)"
                title="Раскрыть текст ответа"
              >
                Вопрос: {{question.name}}
              </a>
            </h5>
          </div>

          <div
            :id="'q_collapse_'+question.id"
            class="panel-collapse in row pt-3 pl-4"
            :class="{collapse: index != 0}"
          >
            <p>{{question.answer}}</p>
          </div>

        </div>
      </div>

      </div>
   </div>

    <div class="row justify-content-center">
      <form @submit.prevent='submitFeedback' class="content-wrapper col-12" id="feedbackForm" name="feedbackForm">
      <h2 class="mb-3 pb-1 border-bottom">Форма обратной связи</h2>
      <div class="form-row">
        <div class="col-12">
          <label class="text-secondary" for="themesList">Выберите тему обращения</label>
          <select class="custom-select mb-3" id="themesList" name="themesList" required>
            <option value="" class="d-none"></option>
            <option value="1">Проблемы с телефонией</option>
            <option value="2">Проблемы с настройками</option>
            <option value="3">Другое</option>
          </select>
        </div>
        <div class="col-12">
          <label class="text-secondary" for="feedbackContent">Опишите суть обращения</label>
          <textarea class="form-control mb-3" id="feedbackContent" name="feedbackContent" rows="3" required></textarea>
        </div>
      </div>
      <button class="btn btn-info px-4" type="submit">Отправить обращение</button>
      </form>
    </div>

  </div>

</template>

<script>
export default {
  data () {
    return {
      questions: [
        {name: 'Как создать сценарий разговора и управлять им?', id: 10, answer: 'lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem '},
        {name: 'Как начать принимать звонки в приложении?', id: 1, answer: 'lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem '},
        {name: 'Как получить статистику по работе операторов?', id: 2, answer: 'ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum '},
        {name: 'Как ограничить доступ сотрудников к определенным разделам?', id: 3, answer: 'ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum ipsum '}
      ]
    }
  },
  computed: {},
  methods: {
    showForm: function (roleID) {
      let targetBlock = document.querySelector(event.target.hash)
      if (!targetBlock.classList.contains('collapse')) {
        targetBlock.classList.add('collapse')
        return
      }
      let panels = document.querySelectorAll('.panel-collapse')
      for (let i = 0; i < panels.length; i++) {
        panels[i].classList.add('collapse')
      }
      targetBlock.classList.toggle('collapse')
    },
    submitFeedback: function () {
      let appeal = {
        id: Math.round(Math.random() * 10),
        theme: document.forms.feedbackForm.elements.themesList.value,
        content: document.forms.feedbackForm.elements.feedbackContent.value
      }
      document.forms.feedbackForm.reset()
      console.dir(appeal)
      /* this.axios.post('#', appeal)
        .then(this.modalSuccess) */
      alert(`Обращение успешно отправлено в службу поддержки под номером ${appeal.id}`) //! вызов модалки привязать к получению ответа от сервера
    },
    modalSuccess: function () {

    }
  },
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/help.vue